module.exports = __webpack_public_path__ + "img/fi-eduhouse-guide.de4b6a45.png";